// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20spR","type":"styles_type__1pPeV","choices":"styles_choices__1cuHi"};